<template>
    <div class="container">
        <div class="handle-box-search">
            <el-row class="head-search">
                <el-col :span="12">
                        <span class="title">三方名称</span>
                        <el-select
                            v-model="search_data.third_id"
                            placeholder="请选择三方"
                            @visible-change="sfVisibleChange"
                            @change="sfChange"
                            @keyup.enter.native="searchCooperateThirdAccountLists"
                            clearable
                        >
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item in third" :key="item.third_id" :label="item.third_name" :value="item.third_id">
                            </el-option>
                        </el-select>
                    </el-col>
            </el-row>

            <el-button type="primary" icon="el-icon-search" @click="searchCooperateThirdAccountLists">搜索</el-button>
            <el-button @click="add_isShow = !add_isShow">添加</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
            <el-button @click="water_isShow = !water_isShow">流水</el-button>
        </div>

        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column prop="id" label="id"> </el-table-column>

            <el-table-column prop="account_name" label="三方名称"> </el-table-column>

            <el-table-column prop="city.name" label="归属城市"> </el-table-column>

            <el-table-column prop="balance" label="账户金额">
                <template slot-scope="scope">
                    <span style="color: rgb(233, 161, 6)"> {{ scope.row.balance }}元 </span>
                </template>
            </el-table-column>

            <el-table-column prop="time.YmdHis" label="更新时间"> </el-table-column>
            <el-table-column label="操作" min-width="100">
       
                <template slot-scope="scope">
                    <el-button type="primary" @click="editSanFang(scope.row)">编辑</el-button>
                    <el-button type="primary" @click="thirdAccountRecordLists(scope.row)">账户流水</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>

        <!-- 添加组件 -->
        <addThirdAccountSubmit :isShow="add_isShow" @onSubmit="cooperateThirdAccountLists"></addThirdAccountSubmit>
        <!-- 流水组件 -->
     
        <waterAccountRecordLists :isShow="water_isShow"></waterAccountRecordLists>

        <!-- 编辑组件 -->
        <editThirdAccountSubmit :isShow="edit_isShow" @onSubmit="cooperateThirdAccountLists" :data="editThirdAccountSubmit_data"></editThirdAccountSubmit>

        <!--  账单  -->
        <thirdAccountRecordLists :data="editThirdAccountSubmit_data" :isShow="recordLists_isShow" :name="third_name"></thirdAccountRecordLists>
    </div>
</template>

<script>
var _this;
import addThirdAccountSubmit from './addThirdAccountSubmit.vue';
import waterAccountRecordLists from './waterAccountRecordLists.vue';
import editThirdAccountSubmit from './editThirdAccountSubmit.vue';
import thirdAccountRecordLists from './thirdAccountRecordLists.vue';
export default {
    components: {
        addThirdAccountSubmit,
        editThirdAccountSubmit,
        thirdAccountRecordLists,
        waterAccountRecordLists
    },

    data() {
        return {
            third: '',
            water_isShow: false,
            third_name: '',
            recordLists_isShow: false,
            add_isShow: false,
            edit_isShow: false,
            editThirdAccountSubmit_data: '',

            // 存放表格数据
            tableData: [],

            //翻页数据
            search_data: {
                page: 1,
                limit: 10,
                third_id: ''
               
            },

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.searchCooperateThirdAccountLists();
      
    },

    methods: {
        sfVisibleChange(val) {
            if (val) {
                _this
                    .$post('/Cooperatewine/thirdAccountList')
                    .then((res) => {
                        _this.third = res.data;
                    })
                    .catch((err) => {});
            }
        },
        sfChange(val) {
            _this.search_data.third_id = val;
            _this.cooperateWineBatchLists();
        },
       

        thirdAccountRecordLists(e) {
            _this.third_name = e.account_name;
            _this.editThirdAccountSubmit_data = e.account_code;
            _this.recordLists_isShow = !_this.recordLists_isShow;
        },
        editSanFang(e) {
            _this.edit_isShow = !_this.edit_isShow;
            _this.third_name = e.account_name;
            _this.editThirdAccountSubmit_data = e.account_code;
        },

        searchCooperateThirdAccountLists() {
            _this.search_data.page = 1;
            _this.cooperateThirdAccountLists();
        },

     
        cooperateThirdAccountLists() {
            _this
                .$post('/Cooperatewine/cooperateThirdAccountLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    _this.result_data = res;
                })
                .catch((err) => {});
        },
        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.cooperateThirdAccountLists();
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 200px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-form-item.el-form-item--small {
    width: 100%;
}

.demo-table-expand {
    font-size: 0;
}

.demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}

.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
}

.el-form-item__content span {
    display: inline-block;
    width: 100%;
    word-wrap: break-word;
    white-space: normal;
}
</style>
